<template>
  <div class="math-processing-stat">
    <a-row class="filters" :gutter="10" type="flex">
      <a-col flex="2" style="min-width: 20vw; height:40px;">
        <date-picker
          style="width: 100%; height: 40px;"
          label="Дата:"
          :value="date"
          :enabledDatesArray="dates"
          format="YYYY-MM-DD"
          class="white-date-picker"
          @input="date = $event"
        />
      </a-col>
      <template>
        <a-col flex="1">
          <input-enum
            v-model="classificator"
            style="height: 40px"
            :options="Object.keys(classificator_arr)"
            :allowClear="false"
          />
        </a-col>

        <a-col flex="auto">
          <input-enum
            v-model="category"
            style="height: 40px" :options="categories" :allowClear="false"
            @search="categorySearch"
          />
        </a-col>
      </template>

      <template>
        <a-col flex="1">
          <input-enum
            v-model="region"
            style="height: 40px" :options="regions" :allowClear="false"
          />
        </a-col>

        <a-col flex="2" style="max-width: 30vw">
          <input-enum
            v-model="city"
            style="height: 40px" :options="cities" :allowClear="false"
          />
        </a-col>
      </template>
    </a-row>

    <div>
      <div class="block-wrapper">
        <the-table
          :config="tableHeader"
          :defaultSort="[]"
          :data="tableData"
          :canHideColumns="false"
        />
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import TheTable from '../../pages/table/table/TheTable';
import inputEnum from "@/components/base/InputEnum";
import {apolloClient} from "@/apolloClient";
import TABLE_QUERY from "@/queries/table";
import {bus, storage} from "@/helpers";
import DatePicker from "@/components/base/DatePicker"

const apiUrl = process.env.VUE_APP_ROSSTAT_API_URL;
const esUrl = process.env.VUE_APP_ELASTIC_URL;
const cutOffDict = {
  1: 'Отсечено оптовых цен',
  3: 'Отсечено ошибочных цен',
  4: 'Отсечено по уровням цен',
  5: 'Отсечено индивидуальных скидок',
  6: "Отнесено в резерв",
  7: "Оценка достаточности. Отсечено"
}
export default {
  name: 'MathProcessingStat',
  components: {
    TheTable,
    inputEnum,
    DatePicker
  },

  data: () => ({
    dates: [],
    date: '',
    categories: [],
    category: '',
    category_search: '',
    list_okato: [],
    selected_okato: '',
    cities: [],
    city: '',
    regions: [],
    region: '',
    classificator: 'КИПЦ',
    tableHeader: {
      displayFields: [
        {
          label: 'Название',
          field: 'Название',
          index: 'Название',
          name: 'Название',
          width: 500,
        },
        {
          label: 'Количество',
          field: 'Количество',
          index: 'Количество',
          name: 'Количество',
        },
      ],
    },
    tableData: {
      rows: [],
    },
  }),
  computed: {
    // typeTitles() {
    //   return [types.TYPE_DIAGRAM, types.TYPE_TABLE];
    // },
    classificator_arr() {
      return { КИПЦ: 'kipc', ИПЦ: 'ipc', ОКПД2: 'okpd2' };
    },
  },
  watch: {
    date() {
      storage.set('dateFilter', this.date)
      this.refetch();
    },
    category() {
      this.refetch();
    },
    classificator() {
      this.get_categories();
    },
    selected_okato() {
      this.refetch();
    },
    region() {
      this.get_cities();
    },
    city() {
      this.selected_okato = this.city_code_arr[this.city]
    },
  },
  mounted(){
    this.get_dates()
    this.get_categories()
    this.get_regions()
    if (this.classificator_arr) {
      this.classificator = Object.keys(this.classificator_arr).includes('ИПЦ')
        ? 'ИПЦ'
        : Object.keys(this.classificator_arr)[0];
    }
  },
  methods: {
    categorySearch(value) {
      this.category_search = value
      this.get_categories()
    },
    async get_categories() {
      const prevCategory = this.category;
      const client = apolloClient
        .query({
          ...TABLE_QUERY,
          variables: {
            type: 'FNSClassesConfiguration',
            page: 0,
            pageSize: 999,
            filters: [
              {
                field: `${this.classificator_arr[this.classificator]}Enabled`,
                value: 'true',
                operator: 'EQUALS',
              },
              {
                field: "name",
                value: this.category_search,
                operator: "ILIKE"
              }
            ],
          },
        })
        .catch((error) => {
          bus.$emit('error', {
            from: 'configFormLayout',
            description: `Ошибка получения конфига таблицы категорий`,
          });
          throw error;
        });
      client.then((res) => {
        const arr = [];
        res.data.table.documents.forEach(({ data }) => {
          arr[data.name] = data[this.classificator_arr[this.classificator]];
        });
        const favorites = ['Картофель', "Морковь", 'Сметана'];
        this.categories = favorites.concat(
          Object.keys(arr)
            .sort()
            .filter((el) => !favorites.includes(el)),
        );
        if (!this.categories.includes(prevCategory)) {
          this.category = this.categories[0];
        }
      });
      this.category_search = ''
    },
    async get_regions() {
      const prevRegion = this.region;
      const client = apolloClient
        .query({
          ...TABLE_QUERY,
          variables: {
            type: 'Region',
            page: 0,
            pageSize: 10000,
          },
        })
        .catch((error) => {
          console.log(error);
          bus.$emit('error', {
            from: 'configFormLayout',
            description: `Ошибка получения конфига таблицы Region`,
          });
          throw error;
        });
      client.then((res) => {
        const arr = [];
        res.data.table.documents.forEach(({ data }) => {
          arr[data.name_region] = data.okato;
        });
        this.regions = Object.keys(arr);
        if (!this.regions.includes(prevRegion)) {
          this.region = this.regions[0];
          this.region = 'Москва';
        }
        this.region_code_arr = arr;
        this.get_cities();
      });
    },
    async get_cities() {
      if (!this.region) return;
      const prevCity = this.city;
      await this.axios
        .get(
          `${apiUrl}/report/get_okato_list_for_region?region=${this.region_code_arr[this.region]}&date=${this.date}`,
          // {
          //   headers: {
          //     'finch-auth': `Bearer ${storage.get('authToken')}`
          //   }
          // }
        )
        .then(({data}) => {
          Object.keys(data).forEach((key) => {
            while (data[key].slice(-1) === '0' && data[key].length > 2) {
              data[key] = data[key].slice(0, -1);
            }
          });
          this.cities = Object.keys(data);
          if (!this.cities.includes(prevCity)) {
            this.city = this.cities[0];
          }
          this.selected_okato = data[this.city];
          this.city_code_arr = data;
        });
    },
    async get_dates() {
      this.date = storage.get('dateFilter')
      const response = await this.axios.get(`${apiUrl}/report/get_date_v2`, {
        params: {
          type_report: 'identified-annual-processing',
        },
        // headers: {
        //   'finch-auth': `Bearer ${storage.get('authToken')}`
        // }
      });

      this.dates = response.data.sort().reverse();
      if (!this.date) {
        this.date = this.dates[0];
        storage.set('dateFilter', this.date)
      }
    },
    async refetch() {
      if (!this.date || !this.category || !this.selected_okato) return null
      const query = {
        size: 0,
        query: {
          "bool": {
            "must": [
              {
                "bool": {
                  "should": [
                    {
                      "wildcard": {
                        "ОКАТО": {
                          "value": `${this.selected_okato}*`
                        }
                      }
                    },
                    {
                      "wildcard": {
                        "Товар представитель.keyword": {
                          "value": this.category
                        }
                      }
                    }
                  ],
                  "minimum_should_match": 2
                }
              }
            ]
          }
        },
        aggs: {
          whateevcerv: {
            terms: {
              field: 'cut_off',
              size: 100000,
            },
          },
        },
      };
      this.dataRequest = axios.CancelToken.source();
      await this.axios
        .post(`${esUrl}/identified-annual-processing_${this.date}/_search?`, query, {
          cancelToken: this.dataRequest.token,
        })
        .then(({data}) => {
          const totalCount = data.hits.total.value
          const rows = data.aggregations.whateevcerv.buckets
          const arr = []
          const nullCutOff = rows.find((el)=>el.key===0)?.doc_count || 0
          arr.push({'Название': 'Всего', 'Количество':totalCount})
          Object.keys(cutOffDict).forEach((key)=>{
            const element = rows.find((el)=>Number(el.key)===Number(key))
            if (element){
              arr.push({
                'Название': cutOffDict[key],
                'Количество':  `${element.doc_count} (${Math.round(element.doc_count*100 / totalCount)}%)` || 0
              })
            }
            else {
              arr.push({'Название': cutOffDict[key], 'Количество': 0})
            }
          })
          arr.push({'Название': 'Итоговая выборка', 'Количество':`${nullCutOff} (${Math.round(nullCutOff*100 / totalCount)}%)`})
          this.tableData.rows = arr
        })
        .catch((error)=>{
          this.tableData.rows = []
          throw error
        });
    }
  }
};
</script>

<style lang="scss">
.machine-learning-stat {
  .chart {
    height: 300px;
  }
}
</style>
